/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    saveOperationCost,
};

async function saveOperationCost(bulkModel) {
    const response = await CommonPost('/api/OperationCost/SaveOperationCostBulk', null, bulkModel);
    return response;
}
